import initV2, { getPopTabTitleV2 } from './wincall-v2-init.js'
import initV2_5, { getPopTabTitleV25 } from './wincall-v2-5-init.js'
import initV3 from './wincall-v3-init.js'
import { addTab } from '../utils.js'
import i18n from '@/i18n'

export const initWinCallSdk = (params, version) => {
  console.log('wincall-->version:', version)
  switch (version + '') {
    case '3':
      initV3(params)
      break;
    case '2-5':
      initV2_5(params)
      break;
    case '2':
      initV2(params)
      break;
    default:
      initV2(params)
      break;
  }
}

export const popScreenWithOutOutbound = (phone, options = {})=>{
  let { LOGIN_USER: { USER_ID, USER_NUM }, isEnableCrm = false, POP_ADDRESS = {}, WINCALL_VERSION } = window.vueInstance._config || {}
  const { public_callout, public_old_ekt } = POP_ADDRESS
  const { call_out_setting } = options
  let title = i18n.t('wincall.businessAcceptance')
  let otherParams = {}
  // 如果是v2电话条，且是新工单手机号组件按拨号键不呼出的情况
  const version = WINCALL_VERSION + ''
  if(!['3'].includes(version) && call_out_setting === 1) {
    if(version === '2-5') {
      title = getPopTabTitleV25(phone)
    } else {
      title = getPopTabTitleV2(phone)
    }
    otherParams = { call_out_setting }
  }
  // 开启新的crm了
  if(isEnableCrm){
    addTab(title, `${public_callout}?user_id=${USER_ID}&user_num=${USER_NUM}&phone=${phone}`, "menu_icon", otherParams);
  }else{
    addTab(title, `${public_old_ekt}&phone=${phone}`, "menu_icon", otherParams);
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/wincall-init/index.js